import { useEffect } from 'react';
import { subscribeToSettings } from '../../admin/services/settingsService';

export default function SEO() {
  useEffect(() => {
    const unsubscribe = subscribeToSettings((data) => {
      if (!data) return;

      // Update Title
      const title = data.seoTitle || data.title || 'ALL BLACK SCREEN';
      document.title = title;

      // Update Meta Description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = data.seoDescription || 'The ultimate black screen tool.';

      // Update Meta Keywords
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = data.seoTags || 'black screen, monitor test';
    });

    return () => unsubscribe();
  }, []);

  return null; // This component doesn't render anything
}
